const strainFightingArts = [
    {
        "name": "Story of Blood 1",
        "level": "I",
        "rules": "At some point in your life, you learned a miraculous thing! You cannot recall who taught you or what it was. For a moment, you see a spectrum of colors in your blood . The first time you gain a bleeding token during the showdown, gain +1 survival.",
        "observationCondition": "When Endeavor is spent at Bloodletting or Sacrifice, gain +1 Observation",
        "boxes": 4,
        "levelUp": "Story of Blood 2",
        "group": "10 Anniversary White Speaker"
    },
    {
        "name": "Story of Blood 2",
        "level": "II",
        "rules": "You dream of your skin hardening and turning deep red. Your own image turns your stomach. Spend Activation to convert a bleeding token into scab armor. Add 1 to any hit location and suffer 1 brain damage.",
        "observationCondition": "When you use this while you have 4+ bleeding tokens, gain +1 Observation",
        "boxes": 4,
        "levelUp": "Story of Blood 3",
        "group": "10 Anniversary White Speaker"
    },
    {
        "name": "Story of Blood 3",
        "level": "III",
        "rules": "The red creature of your nightmares wears your skin and speaks of unending torment and eternal life. Spend Activation to convert a bleeding token into scab armor. Add 1 to any hit location.",
        "observationCondition": "When another survivor dies from bleeding tokens, gain +1 Observation",
        "boxes": 3,
        "levelUp": "Story of Blood 4",
        "group": "10 Anniversary White Speaker"
    },
    {
        "name": "Story of Blood 4",
        "level": "IV",
        "rules": "You peel back the monster's skin to reveal a mass of blood with your likeness. It hangs in the air briefly before collapsing and washing the wasteland red. Spend Activation to convert a bleeding token into scab armor. "+
                 "Add 1 to all hit locations. You may spend your bleeding tokens in place of survival.",
        "observationCondition": "When you use this, gain +1 Observation\nYou stress your heart. Roll 1d10. On a 6+, lose 1 Observation. Otherwise, you have a heart attack and die.",
        "boxes": 7,
        "levelUp": null,
        "group": "10 Anniversary White Speaker"
    },
    {
        "name": "Backstabber",
        "level": null,
        "rules": "On a Perfect hit with a dagger, your first wound attempt in that attack gains Devastating 1. When you attack a monster with a dagger from its blind spot, if you have the Hoarder or Secretive disorder, increase the range of your Perfect hits by 1.",
        "observationCondition": null,
        "boxes": null,
        "levelUp": null,
        "group": "Echoes of Death 1"        
    },
    {
        "name": "Ethereal Pact",
        "level": null,
        "rules": "Add +3 to your brain trauma rolls. When you suffer the Impossible!, brain trauma, the fungus in your head connects to the dreaming. "+
                 "Story Event Birth of a Savior and choose a dream. (If you've already reached Age 2, you cannot gain your dream's secret fighting art.) If you are a savior, this fighting art has no effect.",
        "observationCondition": null,
        "boxes": null,
        "levelUp": null,
        "group": "Echoes of Death 1,"
    },
    {
        "name": "Giant's Blood",
        "level": null,
        "rules": "You overproduce growth hormones! When you gain this fighting art, gain +1 strength, -1 evasion permanently. You may consume skulls. If you do, gain the Marrow Hunger impairment.",
        "observationCondition": null,
        "boxes": null,
        "levelUp": null,
        "group": "Echoes of Death 1"
    },
    {
        "name": "Infinite Lives",
        "level": null,
        "rules": "You cannot create new memories. You cannot gain new fighting arts or disorders. When you would gain one, instead gain a new lifetime! "+
                 "Give yourself a new name and a once per lifetime reroll. (Gain +1 survival for naming. Gain the reroll regardless of principle. Only 1 once per lifetime roll at a time.)",
        "observationCondition": null,
        "boxes": null,
        "levelUp": null,
        "group": "Echoes of Death 1"
    },
    {
        "name": "Convalescer",
        "level": "I",
        "rules": "Sympathy and tenderness elevate your care. Whenever you remove bleeding tokens, gain survival, or add armor points, increase this benefit by 1. (e.g. if you use Bandages on another survivor, they remove up to 3 bleeding tokens.) "+
                 "In contrast to your care, your attacks become more crude. They gain the club keyword.",
        "observationCondition": null,
        "boxes": null,
        "levelUp": null,
        "group": "Echoes of Death 2"
    },
    {
        "name": "Infernal Rhythm",
        "level": "I",
        "rules": "You may spend Activation to play an instrument in your gear grid. Reveal the next 3 monster hit locations, then put them back in any order. Whenever you activate an instrument, gain a lantern token. "+
                 "At the start of another survivor's act, you may spend 5 lantern tokens to stir their blood. They gain Movement and Activation.",
        "observationCondition": null,
        "boxes": null,
        "levelUp": null,
        "group": "Echoes of Death 2"
    },
    {
        "name": "Rolling Gait",
        "level": "I",
        "rules": "Spend Activation to notch an arrow. Your next attack with a bow ignores cumbersome. At the end of your attack with a bow or arrow, if you hit the monster from outside it's facing, it gains a flinch token. "+
                 "Flinch token: When a monster with a flinch token attempts to perform Reaction, cancel Reaction and discard this token.",
        "observationCondition": null,
        "boxes": null,
        "levelUp": null,
        "group": "Echoes of Death 2"
    },
    {
        "name": "Shielderang",
        "level": "I",
        "rules": "You are impervious behind your shield. If you have a shield in your gear grid, ignore the first severe injury you suffer each showdown. "+
                 "If you have Shield Specialization, shields in your gear grid gain Reach 3 and +1 strength for each weapon proficiency you have beyond 3.",
        "observationCondition": null,
        "boxes": null,
        "levelUp": null,
        "group": "Echoes of Death 2"
    },
    {
        "name": "Armored Fist",
        "level": "I",
        "rules": "Requires Fist & Tooth Proficiency. Your Fist & Tooth attacks gain strength equal to the current armor value of your arms hit location.",
        "observationCondition": null,
        "boxes": null,
        "levelUp": null,
        "group": "Echoes of Death 3"
    },
    {
        "name": "Dark Manifestation",
        "level": "I",
        "rules": "Once per round, at the start of your act, you may spend the requisite insanity to perform one of the following abilities: "+
                 "3 Gain +2 strength until the end of the round. 6 Perform Block 1. 13 If adjacent to the monster, roll 1d10. On a 6+, you touch the monster, it suffers 1 wound.",
        "observationCondition": null,
        "boxes": null,
        "levelUp": null,
        "group": "Echoes of Death 3"
    },
    {
        "name": "Stockist",
        "level": "I",
        "rules": "You may Concentrate. If you do, perform Stock Shot at the start of your next act. Stock Shot: Activate a bow in your gear grid and attack the monster. "+
                 "For this attack, you bow's Range and strength are equal to the number of resources in the settlement storage. Limit once per showdown.",
        "observationCondition": null,
        "boxes": null,
        "levelUp": null,
        "group": "Echoes of Death 3"
    },
    {
        "name": "Sword Oath",
        "level": "I",
        "rules": "When you gain this, write the name of any sword gear on your record sheet. Note each time you wound with the named sword. If you have wounded 18+ times with this sword, it gains Devastating 1 and Sentient while you have it equipped. "+
                 "When you suffer the Flee brain trauma, lose this fighting art.",
        "observationCondition": null,
        "boxes": null,
        "levelUp": null,
        "group": "Echoes of Death 3"
    }
];


export default strainFightingArts;